import { useEffect } from "react";
import qs from "qs";

import { useGetFormSectionsByIdQuery, useGetAssignmentByIdQuery } from "../../../../redux/services/assignmentApi";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import "./print.css";
import { setAuthData } from "../../../../redux/slices/authSlice";
import TermsAndConditions from "./TermsAndConditions";
import PrintFormSection from "./PrintFormSection";
import Undertaking from "./Undertaking";
import { localizeDateTime } from "../../../../utils";

const PrintForm = (props: any) => {
  const dispatch = useDispatch();
  const searchParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const { accessToken, client, uid, user } = searchParams;
  const validAuthParams = accessToken && client && uid;
  if (validAuthParams) dispatch(setAuthData({ accessToken, client, uid, user }));

  const params = useParams();
  const surveyId = params?.surveyId;
  const installationId = params?.installationId;
  const visitId = params?.visitId;

  const { data: assignmentData = {} } = surveyId
    ? useGetAssignmentByIdQuery(surveyId)
    : installationId
      ? useGetAssignmentByIdQuery(installationId)
      : visitId ? useGetAssignmentByIdQuery(visitId) : {};

  const printData = assignmentData?.assignment;

  const { data, isLoading, isFetching, refetch } = useGetFormSectionsByIdQuery(
    surveyId || installationId || visitId
  );

  const form_sections = data?.form_sections || [];

  useEffect(() => {
    document.title = printData?.ecb_visit_code || printData?.ecb_survey_code || printData?.ecb_install_code || "echargebays";
    return () => {
      document.title = "eChargeBays";
    };
  }, [printData]);

  return (
    <div>
      <PrintFormSection
        displayLinks={props.displayLinks}
        customerReport={props.customerReport}
        form_sections={visitId ? form_sections.filter((x: any) => ["in_visit", "pre_visit", "post_visit"].includes(x.section_type)) : form_sections.filter((x: any) => ["in_survey", "pre_survey", "post_survey"].includes(x.section_type))}
        printData={printData}
        installationId={installationId}
        surveyId={surveyId}
        visitId={visitId}
      />

      {surveyId && (
        <>
          <div style={{ pageBreakBefore: "always" }}>
            <TermsAndConditions printData={printData} />
          </div>
        </>
      )}

      {installationId && (
        <>
          {printData?.install_type === "installation_pending" && <Undertaking />}
          <br />
          <div style={{ display: "flex", gap: 2, justifyContent: "space-between", fontSize: 11 }}>
            <div
              style={{ border: "1px solid black", width: "200px", height: "170px", padding: "8px" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                {printData?.agent_sign ? (
                  <>
                    <p>Installation done by:</p>
                    <img src={printData?.agent_sign} width={200} height={100} />
                    <p>Installer Partner Company & Person Name</p>
                  </>
                ) : (
                  <>
                    <p>Signature:</p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p>Installer Partner Company & Person Name</p>
                  </>
                )}
              </div>
            </div>
            <div
              style={{ border: "1px solid black", width: "200px", height: "170px", padding: "8px" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                {printData?.ecb_sign ? (
                  <>
                    <p></p>
                    <img src={printData?.ecb_sign} width={200} height={110} />
                    <p>Signature of eCB Rep [Name and Date]</p>
                  </>
                ) : (
                  <>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p>Signature of eCB Rep [Name and Date]</p>
                  </>
                )}
              </div>
            </div>
            <div
              style={{ border: "1px solid black", width: "200px", height: "170px", padding: "8px" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                {printData?.customer_sign ? (
                  <>
                    <p></p>
                    <img src={printData?.customer_sign} width={200} height={110} />
                    <p>Signature of Customer {localizeDateTime(printData?.customer_signed_at)}</p>
                  </>
                ) : (
                  <>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p>Signature of Customer [Date]</p>
                  </>
                )}
              </div>
            </div>
          </div>
          <br />
          <div
            style={{
              border: "1px solid Grey",
              textAlign: "center",
              borderRadius: 4
            }}
          >
            <p style={{ fontSize: 10, margin: 2 }}>
              eChargeBays; L29 - L34, First Floor, Block L Connaught Place Delhi-110001 |
              contact@echargebays.com
            </p>
            <p style={{ fontSize: 10, fontWeight: 500, margin: 2 }}>
              Copyright (C) {new Date().getFullYear()} Echargebays Emobility Pvt Ltd. All rights
              reserved.
            </p>
          </div>
        </>
      )}

      {visitId && (
        <>
          {printData?.install_type === "installation_pending" && <Undertaking />}
          <br />
          <div style={{ display: "flex", gap: 2, justifyContent: "space-between", fontSize: 11 }}>
            <div
              style={{ border: "1px solid black", width: "200px", height: "170px", padding: "8px" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                {printData?.agent_sign ? (
                  <>
                    <p></p>
                    <img src={printData?.agent_sign} width={200} height={100} />
                    <p>Signature of person visiting and co name</p>
                  </>
                ) : (
                  <>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p>Signature of person visiting and co name</p>
                  </>
                )}
              </div>
            </div>
            <div
              style={{ border: "1px solid black", width: "200px", height: "170px", padding: "8px" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                {printData?.customer_sign ? (
                  <>
                    <p></p>
                    <img src={printData?.customer_sign} width={200} height={110} />
                    <p>Signature of Customer {localizeDateTime(printData?.customer_signed_at)}</p>
                  </>
                ) : (
                  <>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p>Signature of Customer [Date]</p>
                  </>
                )}
              </div>
            </div>
          </div>
          <br />
          <div
            style={{
              border: "1px solid Grey",
              textAlign: "center",
              borderRadius: 4
            }}
          >
            <p style={{ fontSize: 10, margin: 2 }}>
              eChargeBays; L29 - L34, First Floor, Block L Connaught Place Delhi-110001 |
              contact@echargebays.com
            </p>
            <p style={{ fontSize: 10, fontWeight: 500, margin: 2 }}>
              Copyright (C) {new Date().getFullYear()} Echargebays Emobility Pvt Ltd. All rights
              reserved.
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default PrintForm;
